import React from 'react';
import { LucideIcon } from 'lucide-react';

export interface MetricCardProps {
  title: string;
  subtitle?: string;
  value: string | number;
  icon?: LucideIcon | string;
  description?: string;
  isEmpty?: boolean;
  emptyMessage?: string;
  className?: string;
}

const MetricCard: React.FC<MetricCardProps> = ({
  title,
  subtitle,
  value,
  icon: Icon,
  description,
  isEmpty = false,
  emptyMessage,
  className = ""
}) => {
  const renderIcon = () => {
    if (!Icon) return null;
    
    if (typeof Icon === 'string') {
      return <span className="text-2xl">{Icon}</span>;
    }
    
    return <Icon className="w-4 h-4 text-white" />;
  };

  return (
    <div className={`flex flex-col items-center ${className}`}>
      {/* Value */}
      <div className="text-[24px] font-bold text-white mb-2">
        {value}
      </div>
      
      {/* Description */}
      <p className="text-[10px] text-gray-400 text-center">
        {isEmpty && emptyMessage ? emptyMessage : description}
      </p>
    </div>
  );
};

export default MetricCard;
